// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.root[data-v-50ef3d56]
	{
		font-size: 16px;
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 100%;
		height: 100%;
}
.clientMenu[data-v-50ef3d56]
	{
		position: sticky;
		top: 0px;
}
.head[data-v-50ef3d56]
	{
		width: 100%;
}
.body[data-v-50ef3d56]
	{
		display: flex;
		position: relative;
		width: 100%;
		overflow: auto;
		flex: 1 1 auto;
}
.body[data-v-50ef3d56] > *:first-child
		{
}
.body[data-v-50ef3d56] > *:last-child
		{
			flex: 1 1 auto;
}
.cmsConsole[data-v-50ef3d56]
	{
		flex: 0 0 auto;
}
`, "",{"version":3,"sources":["webpack://./www/vues/client/ClientLayout.vue"],"names":[],"mappings":";AA+CC;;EAEC,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACb;AAEA;;EAEC,gBAAgB;EAChB,QAAQ;AACT;AAEA;;EAEC,WAAW;AACZ;AAEA;;EAEC,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,cAAc;AACf;AAEC;;AAEA;AAEA;;GAEC,cAAc;AACf;AAED;;EAEC,cAAc;AACf","sourcesContent":["<template>\r\n\t<div class=\"root\">\r\n\t\t<div class=\"head\">\r\n\t\t\t<ClientTopNav></ClientTopNav>\r\n\t\t</div>\r\n\t\t<div class=\"body\">\r\n\t\t\t<ClientMenu class=\"clientMenu\"></ClientMenu>\r\n\t\t\t<router-view></router-view>\r\n\t\t</div>\r\n\t\t<CmsConsole v-if=\"isOnCms\" class=\"cmsConsole\" />\r\n\t</div>\r\n</template>\r\n\r\n<script>\r\n\timport ClientTopNav from 'appRoot/vues/client/ClientTopNav.vue';\r\n\timport ClientMenu from 'appRoot/vues/client/ClientMenu.vue';\r\n\timport EventBus from 'appRoot/scripts/EventBus';\r\n\timport CmsConsole from 'appRoot/vues/client/controls/CmsConsole.vue';\r\n\r\n\texport default {\r\n\t\tcomponents: { ClientTopNav, ClientMenu, CmsConsole },\r\n\t\tdata: function ()\r\n\t\t{\r\n\t\t\treturn {\r\n\t\t\t};\r\n\t\t},\r\n\t\tcreated()\r\n\t\t{\r\n\t\t},\r\n\t\tmounted()\r\n\t\t{\r\n\t\t\tEventBus.OnResize();\r\n\t\t},\r\n\t\tcomputed:\r\n\t\t{\r\n\t\t\tisOnCms()\r\n\t\t\t{\r\n\t\t\t\treturn EventBus.isOnCms;\r\n\t\t\t}\r\n\t\t},\r\n\t\tmethods:\r\n\t\t{\r\n\t\t}\r\n\t};\r\n</script>\r\n\r\n<style scoped>\r\n\t.root\r\n\t{\r\n\t\tfont-size: 16px;\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: column;\r\n\t\talign-items: center;\r\n\t\twidth: 100%;\r\n\t\theight: 100%;\r\n\t}\r\n\r\n\t.clientMenu\r\n\t{\r\n\t\tposition: sticky;\r\n\t\ttop: 0px;\r\n\t}\r\n\r\n\t.head\r\n\t{\r\n\t\twidth: 100%;\r\n\t}\r\n\r\n\t.body\r\n\t{\r\n\t\tdisplay: flex;\r\n\t\tposition: relative;\r\n\t\twidth: 100%;\r\n\t\toverflow: auto;\r\n\t\tflex: 1 1 auto;\r\n\t}\r\n\r\n\t\t.body > *:first-child\r\n\t\t{\r\n\t\t}\r\n\r\n\t\t.body > *:last-child\r\n\t\t{\r\n\t\t\tflex: 1 1 auto;\r\n\t\t}\r\n\r\n\t.cmsConsole\r\n\t{\r\n\t\tflex: 0 0 auto;\r\n\t}\r\n</style>"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
